import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import axios from "axios";
import { toast } from "react-toastify";

export const SocialMediaLinks = () => {
  const [SocialMedia, setSocialMedia] = useState({
    ID: 0,
    Name: "",
    Links: "",

    ImagePath: "",
    SortOrder: 0,
    Image: "",
    OldimagePath: "",
  });
  const [SbrochureList, setSBrochureList] = useState("");
  const [CbrochureList, setCBrochureList] = useState("");

  const [error, setError] = useState({});
  const [refreshflag, setrefreshflag] = useState(0);
  const [refreshGrid, setrefreshGrid] = useState(0);
  const modalRef = useRef(null);
  const [editVisible, setEditVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch("ContactUs/SocialMediaLinkDetails");
        if (response && response.length > 0) {
          setContactUs(response[0]);
          setSBrochureList(
            response[0].sBrochureFile
              ? `${ImageURL}${response[0].sBrochureFile}`
              : ""
          );
          setCBrochureList(
            response[0].cBrochureFile
              ? `${ImageURL}${response[0].cBrochureFile}`
              : ""
          );
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, [refreshflag]);

  const clearForm = () => {
    setSocialMedia({
      ID: 0,
      Name: "",
      Links: "",

      ImagePath: "",
      SortOrder: 0,
      Image: "",
      OldimagePath: "",
    });
    setError({});
    setEditVisible(false);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const validateFields = () => {
    const requiredFields = [
      "faceBook",
      "twitter",
      "instagram",
      "linkedin",
      "contact",
      "emailId",
      "pinterest",
      "vimeo",
      "broucherLink",
      "corporateBroucherLink",
    ];
    const newErrors = {};

    // Regular expression for allowing only numbers (for contact)
    const usPhonePattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    const urlPattern =
      /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?[^\s]*)?(\#[^\s]*)?$/i;

    // const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*$/i;
    const customFieldNames = {
      faceBook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      pinterest: "Pinterest",
      vimeo: "Vimeo",
      emailId: "Email ID",
      broucherLink: "Broucher Link",
      corporateBroucherLink: "Broucher Link",
    };

    requiredFields.forEach((field) => {
      const value = ContactUs[field] || "";
      const fieldName =
        customFieldNames[field] ||
        field
          .replace(/([A-Z])/g, " $1")
          .charAt(0)
          .toUpperCase() + field.slice(1);

      if (value.trim() == "") {
        newErrors[field] = `${fieldName} is required`;
      }

      // Check if "Facebook" is present in the Facebook field
      if (
        field == "faceBook" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("facebook")
      ) {
        newErrors.faceBook = "Please enter a valid Facebook URL.";
      }

      // Check if "Instagram" is present in the Instagram field
      if (
        field == "instagram" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("instagram")
      ) {
        newErrors.instagram = "Please enter a valid Instagram URL.";
      }

      // Check if "Twitter" is present in the Twitter field
      if (
        field == "twitter" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("twitter")
      ) {
        newErrors.twitter = "Please enter a valid twitter URL.";
      }
      if (
        field == "pinterest" &&
        value.trim() !== "" &&
        !/pinterest\.com/.test(value.toLowerCase())
      ) {
        newErrors.pinterest = "Please enter a valid Pinterest URL.";
      }

      // Check if "LinkedIn" is present in the LinkedIn field
      if (
        field == "linkedin" &&
        value.trim() !== "" &&
        !value.toLowerCase().includes("linkedin")
      ) {
        newErrors.linkedin = "Please enter a valid LinkedIn URL.";
      }

      if (
        field === "emailId" &&
        value.trim() !== "" &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      ) {
        newErrors.emailId = "Please enter a valid email address.";
      }

      if (
        field == "contact" &&
        value.trim() !== "" &&
        !usPhonePattern.test(value)
      ) {
        newErrors.contact = "Please enter a valid 10-digit phone number";
      }

      if (
        field == "broucherLink" &&
        value.trim() != "" &&
        !urlPattern.test(value)
      ) {
        newErrors.broucherLink = "Please enter a valid link.";
      }
      if (
        field == "corporateBroucherLink" &&
        value.trim() != "" &&
        !urlPattern.test(value)
      ) {
        newErrors.corporateBroucherLink = "Please enter a valid link.";
      }

      // if (!SbrochureList || SbrochureList.length == 0) {
      //   newErrors.broucherFile = "Broucher File is required";
      // }
    });

    setError(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = SocialMedia.Image?.size > maxSizeInBytes;

    // Validate the link before submitting
    const urlPattern = /^https:\/\/\S+/;
    const isLinkInvalid =
      !SocialMedia.Links || !urlPattern.test(SocialMedia.Links);

    // Validate the entire form
    const formErrors = ValidateForm(e) || {}; // Ensure it returns an object
    formErrors.Links = !SocialMedia.Links; // Show "Link is required" if empty
    formErrors.ValidLink = isLinkInvalid; // Show "Please enter a valid URL" if invalid
    formErrors.InValidFileSize = oversize; // Validate file size

    // If there are any errors, update state and stop submission
    const hasErrors = Object.values(formErrors).some((error) => error);
    if (hasErrors) {
      setError(formErrors);
      return;
    }

    // Proceed with form submission if no errors
    setLoading(true);
    setError((prevError) => ({
      ...prevError,
      InValidFileSize: false,
    }));

    try {
      const formData = new FormData();
      formData.append("ID", SocialMedia.ID);
      formData.append("Name", SocialMedia.Name);
      formData.append("Link", SocialMedia.Links);
      formData.append("OldimagePath", SocialMedia.OldimagePath);
      formData.append("SavedBy", sessionUser());
      if (SocialMedia.Image) {
        formData.append("Image", SocialMedia.Image);
      }

      await corepost("ContactUs/InsertUpdateSocialMedia", formData);
      setLoading(false);

      $("#hide").click();
      setrefreshGrid(refreshGrid + 1);
    } catch (error) {
      console.error(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setError((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));

    setContactUs((prevState) => ({
      ...prevState,
      [name]: value || "",
    }));
  };

  const [removedBrochureIds, setRemovedBrochureIds] = useState([]);

  const handleRemoveFile = async () => {
    setSBrochureList("");
    await corefetch(
      `ContactUs/DeleteBroucher?IsCorporate=${false}&DeletedBy=${sessionUser()}`,
      true,
      false,
      true
    );
  };
  const ChandleRemoveFile = async () => {
    setCBrochureList("");

    await corefetch(
      `ContactUs/DeleteBroucher?IsCorporate=${true}&DeletedBy=${sessionUser()}`,
      true,
      false,
      true
    );
  };

  const [Cloading, setCLoading] = useState(false);

  const ShandleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const validPDFs = files.filter((file) => file.type == "application/pdf");

    if (validPDFs.length !== files.length) {
      setError({ SValidFile: "Files must be valid PDF documents." });
      return;
    }

    const maxFileSize = 30 * 1024 * 1024;
    const oversizedFiles = validPDFs.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      toast.error("File size must not exceed 30 MB.");
      $("#SbFile").val("");
      return;
    }

    setError((prev) => ({
      ...prev,
      SValidFile: "",
      SbroucherFile: false,
    }));

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("broucher", files[0]);
      formData.append("IsCorporate", false);
      formData.append("SavedBy", sessionUser());

      const response = await corepost("ContactUs/SaveBroucher", formData);

      // const brochureDetails = validPDFs.map((file) => ({
      //   filePath: URL.createObjectURL(file),
      //   fileName: file.name,
      //   fileData: file,
      //   IsCorporate: false,
      //   SavedBy: sessionUser(),
      //   RemovedImageIds: "",
      //   isNew: true,
      //   broucherFileID: response,
      // }));
      setSBrochureList(URL.createObjectURL(validPDFs[0]));
    } catch (err) {
      console.error("Error uploading file:", err);
      setError({ broucherFile: "Failed to upload file. Please try again." });
    } finally {
      setLoading(false);
    }

    $("#SbFile").val("");
  };
  const ChandleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const validPDFs = files.filter((file) => file.type === "application/pdf");

    if (validPDFs.length !== files.length) {
      setError({ CValidFile: "Files must be valid PDF documents." });
      return;
    }

    const maxFileSize = 30 * 1024 * 1024;
    const oversizedFiles = validPDFs.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      toast.error("File size must not exceed 30 MB.");
      $("#SbFile").val("");
      return;
    }

    setError((prev) => ({
      ...prev,
      CValidFile: "",
      CorporatebroucherFile: false,
    }));

    setCLoading(true);
    try {
      const formData = new FormData();
      formData.append("broucher", files[0]);
      formData.append("IsCorporate", true);
      formData.append("SavedBy", sessionUser());

      const response = await corepost("ContactUs/SaveBroucher", formData);

      const brochureDetails = validPDFs.map((file) => ({
        filePath: URL.createObjectURL(file),
        fileName: file.name,
        fileData: file,
        IsCorporate: true,
        SavedBy: sessionUser(),
        RemovedImageIds: "",
        isNew: true,
        broucherFileID: response,
      }));

      setCBrochureList(brochureDetails);
    } catch (err) {
      console.error("Error uploading file:", err);
      setError({ broucherFile: "Failed to upload file. Please try again." });
    } finally {
      setCLoading(false);
    }

    $("#CbFile").val("");
  };
  const onRowReorderChange = async (List) => {
    let ID = $(List.newRow).find("td").eq(0).text();
    let oldSortId = $(List.newRow).find("td").eq(1).text();
    let newSortId = $(List.oldRow).find("td").eq(1).text();
    await corefetch(
      `ContactUs/SortSocialMedia?TypeId=${ID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
    );
    setrefreshGrid(refreshGrid + 1);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setSocialMedia((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // If the file is too big
        setSocialMedia((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        // File size is okay
        let temp = SocialMedia;
        temp.Image = file;
        setSocialMedia(temp);

        const reader = new FileReader();
        reader.onloadend = () => {
          setSocialMedia((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setSocialMedia((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const handleEditClick = async (e) => {
    let temp = SocialMedia;

    SocialMedia.ID = e.id;
    SocialMedia.Name = e.name;
    SocialMedia.Links = e.link;

    SocialMedia.Image = e.imagePath;
    SocialMedia.OldimagePath = e.imagePath;

    setSocialMedia(temp);

    setEditVisible(true);
    const modal = new bootstrap.Modal(document.getElementById("Add_Aboutus"));
    modal.show();
  };
  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `ContactUs/DeleteSocailMedia?id=${
          e.id
        }&DeletedBy=${sessionUser()}&FilePath=${e.imagePath}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshGrid(refreshGrid + 1);
      });
    };
    confirmDelete(onDelete);
  };

  return (
    <>
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#Add_Aboutus"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
              {/* )} */}
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow" }}>Note:</span>
                This module supports drag-and-drop functionality, you can easily
                rearrange or move data as needed.
              </i>
              <KendoGrid
                name={"AboutGrid"}
                url={CorebaseURL + "ContactUs/GetSocialMediaLinkDetails"}
                schema={{}}
                columns={[
                  {
                    field: "id",
                    filterable: false,
                    hidden: true,
                  },
                  {
                    field: "sortOrder",

                    hidden: true,
                  },
                  {
                    field: "name",
                    title: "Name",
                    width: 100,
                  },

                  // {
                  //   field: "images",
                  //   title: "Image",
                  //   width: 140,
                  // },

                  {
                    template: function (e) {
                      if (e.imagePath) {
                        return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
                      }
                      return "";
                    },
                    headerTemplate:
                      "<div>Image&nbsp;<span><a href='https://www.flaticon.com/authors/flat-icons' target='_blank' style='color:blue;font-size:12px;text-decoration:underline'><i>Download Icons</i></a>&nbsp;<i class='k-icon k-i-download'></i></span></div>",
                    title: "Image",
                    width: 100,
                  },
                  // {
                  //   field: "thumbImagePath",
                  //   hidden: true,
                  // },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={(e) => handleEditClick(e)}
                onDeleteClick={(e) => {
                  handleDeleteClick(e);
                }}
                paggable={true}
                disableExportExcel={true}
                height={"60vh"}
                refreshWhen={refreshGrid}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Aboutus Modal --> */}
      <div
        className="modal custom-modal fade"
        id="Add_Aboutus"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered aboutus"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="AboutusForm" onSubmit={onSubmit}>
                <input type="hidden" name="ID" value={SocialMedia.ID || 0} />
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Social Media Link Name{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={30}
                      className="form-control field"
                      name="Name"
                      id="Name"
                      value={SocialMedia.Name || ""}
                      placeholder="Name"
                      data-required="true"
                      onChange={(e) => {
                        setSocialMedia((prev) => ({
                          ...prev,
                          Name: e.target.value,
                        }));
                        onValidation("Name", e.target.value);
                      }}
                    />
                    {error.Name && <ErrorMsg text="Name is required" />}
                  </div>
                </div>
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Social Media Link <span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      maxLength={50}
                      className="form-control field"
                      name="Links"
                      id="Links"
                      value={SocialMedia.Links || ""}
                      placeholder="Link"
                      data-required="true"
                      onChange={(e) => {
                        const value = e.target.value;
                        const urlPattern = /^https:\/\/\S+/;
                        // Updated regex to support both HTTP and HTTPS

                        setSocialMedia((prev) => ({
                          ...prev,
                          Links: value,
                        }));

                        // Validate the link and update errors
                        setError((prev) => ({
                          ...prev,
                          Links: !value.trim(), // If empty, show "Link is required"
                          ValidLink: value && !urlPattern.test(value), // If invalid, show "Please enter a valid URL"
                        }));

                        onValidation("Links", value);
                      }}
                    />
                    <CommonErrorMsg
                      text={
                        error.Links
                          ? "Link is required"
                          : error.ValidLink
                          ? "Please enter a valid URL"
                          : ""
                      }
                      IsError={error.Links || error.ValidLink}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">
                      Social Media Icon <span className="text-danger">*</span>
                      <InfoIcon
                        content="Kindly upload only Icons, not regular Images.;
             Ensure the icon size does not exceed 500KB.;
             
             Please upload the icon in JPEG, JPG or PNG format."
                      />
                    </label>

                    <input
                      className="form-control"
                      type="file"
                      name="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {error.Image && <ErrorMsg text="Icon is required" />}
                    {error.ValidFile && (
                      <ErrorMsg text="please upload Icon file only" />
                    )}
                    {error.InValidFileSize && (
                      <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                    )}
                  </div>
                  <div className="row mt-1 mb-3">
                    {SocialMedia.OldimagePath && SocialMedia.ID > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${ImageURL}${SocialMedia.OldimagePath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {SocialMedia.OldimagePath.split("/").pop()}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required="true"
                      value={SocialMedia.Image || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={SocialMedia.OldimagePath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="AboutUS-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
